import type { UIMessage } from '@ai-sdk/react';
import { useAIChatMessagesContext } from './context';
import ReasoningMessagePart from './ReasoningMessagePart';
import TextMessagePart from './TextMessagePart';
import ToolDebugPart from './ToolDebugPart';
import { type ChatMessagePart, isToolPart } from './utils';

type Props = {
  index: number;
  isLastMessage: boolean;
  isStreaming: boolean;
  message: UIMessage;
  part: ChatMessagePart;
};

const MessagePart = ({ index, isLastMessage, isStreaming, message, part }: Props) => {
  const { hideReasoning, hideTools, isDebug, markdownComponents, markdownVariant } = useAIChatMessagesContext();
  const isReasoningStreaming = isStreaming && isLastMessage && index === message.parts.length - 1;

  switch (part.type) {
    case 'reasoning':
      if (hideReasoning) return null;
      return <ReasoningMessagePart isReasoningStreaming={isReasoningStreaming} part={part} />;
    case 'text':
      return <TextMessagePart components={markdownComponents} isStreaming={isStreaming} messageRole={message.role} part={part} variant={markdownVariant} />;
    default:
      if (hideTools && isToolPart(part)) return null;
      return <ToolDebugPart isDebug={isDebug} isStreaming={isStreaming} part={part} />;
  }
};

export default MessagePart;
